/** Meta surfaces a campaign runs on. Each one is billed separately. */
export type MetaPlacement = 'FACEBOOK' | 'INSTAGRAM';

export const META_PLACEMENT_OPTIONS: { value: MetaPlacement; label: string }[] = [
  { value: 'FACEBOOK', label: 'Facebook' },
  { value: 'INSTAGRAM', label: 'Instagram' },
];

export type PaymentStatus =
  | 'PENDING'
  | 'AUTHORIZED'
  | 'CAPTURE_PENDING'
  | 'CAPTURED'
  | 'CANCELED'
  | 'EXPIRED'
  | 'FAILED';

/** Launch result the capture settles against. */
export type LaunchOutcome = 'SUCCESS' | 'CREATE_FAILED' | 'ACTIVATION_FAILED';

/** One billable placement, priced by the backend. */
export interface PaymentLineItem {
  placement: string;
  priceCents: number;
  discountCents: number;
}

/** `GET /campaigns/:id/payment` and the capture/cancel responses. */
export interface CampaignPayment {
  id: string;
  campaignId: string;
  status: PaymentStatus;
  outcome: LaunchOutcome | null;
  currency: string;
  amountCents: number;
  discountCents: number;
  capturedCents: number | null;
  lineItems: PaymentLineItem[];
  failureReason: string | null;
  authorizedAt: string | null;
  capturedAt: string | null;
  canceledAt: string | null;
}

/** `POST /campaigns/:id/payment-intent`: a manual-capture hold to confirm. */
export interface PaymentAuthorization extends CampaignPayment {
  clientSecret: string | null;
}
